import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a Google Analytics 4 `page_view` event on every SPA route change.
 *
 * The base gtag() snippet in /public/index.html loads with
 * `send_page_view: false` so the *initial* pageview is NOT fired
 * automatically — we fire it here on mount together with every subsequent
 * route change. This way route changes and the initial load are both counted
 * uniformly (default gtag config only tracks the very first hard load,
 * which loses all SPA navigation traffic).
 *
 * Mount once inside <BrowserRouter> so useLocation() is available.
 */
const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const path = location.pathname + (location.search || '');
    window.gtag('event', 'page_view', {
      page_path:     path,
      page_location: window.location.href,
      page_title:    document.title,
    });
  }, [location.pathname, location.search]);
};

export default useGoogleAnalytics;
